
function FloodsSystem() {
  return (
    <div>
      <div style={{ width: "100%",  }}>
        <iframe
          src="/FloodSimulation.html" // your HTML file in public folder
          title="MAP Flood"
          width="100%"
          height="850px"
          style={{ border: "none" }}
        />
      </div>
    </div>
  );
}
export default FloodsSystem;